import { MediaType } from '../consts';
export var getMediaFileType = function (fileName) {
    var _a;
    var imageExtensions = [
        'jpg',
        'png',
        'gif',
        'jpeg',
        'jpe',
        'jfif',
        'bmp',
        'heic',
        'heif',
        'tiff',
        'tif',
        'webp',
    ];
    var videoExtensions = [
        'avi',
        'mpeg',
        'mpg',
        'mpe',
        'mp4',
        'mkv',
        'webm',
        'mov',
        'ogv',
        'vob',
        'm4v',
        '3gp',
        'divx',
        'xvid',
        'mxf',
        'wmv',
        'm1v',
        'flv',
        'm2ts',
    ];
    var audioExtensions = ['mp3', 'wav', 'flac', 'm4a', 'wma', 'aac', 'aif', 'aiff'];
    var archiveExtensions = ['zip', 'rar', 'tar', 'gz', 'gzip', 'jar', '7z', 'fgz', 'webarchive'];
    var type = ((_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    if (imageExtensions.includes(type))
        return MediaType.IMAGE;
    if (videoExtensions.includes(type))
        return MediaType.VIDEO;
    if (audioExtensions.includes(type))
        return MediaType.AUDIO;
    if (archiveExtensions.includes(type))
        return 'archive';
    return MediaType.DOCUMENT;
};
//# sourceMappingURL=getMediaFileType.js.map